import React, { useEffect, useRef } from "react";

import Placeholder from "../../assets/Images/ReportsDashboard.svg";
import SteelhausLogo from "../../assets/Images/Steelhaus_Horizontal.svg";
import MaverickLogo from "../../assets/Images/MaverickLogo.svg";
import TrytonLogo from "../../assets/Images/Tryton.png";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function SafetyAppHero(props) {
  const imageRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Scale the image from the bottom center
      gsap.to(imageRef.current, {
        scale: 1.15,
        transformOrigin: "top center",
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".safetyAppHeroContainer",
          start: "top top",
          end: "+=200",
          scrub: 0.5, // ← gives you easing-like smoothness
        },
      });

      // Fade out h1
      gsap.to(".safetyAppHeroContentContainer h1", {
        opacity: 0,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".safetyAppHeroContainer",
          start: "top top",
          end: "bottom top",
          scrub: true,
        },
      });

      // Fade out paragraph
      gsap.to(
        ".heroTextContainer p",
        {
          opacity: 0,
          ease: "power2.out",
          scrollTrigger: {
            trigger: ".safetyAppHeroContainer",
            start: "top top",
            end: "bottom top",
            scrub: true,
          },
        },
        "-1"
      );
    });

    return () => ctx.revert();
  }, []);

  return (
    <>
      <section className="safetyAppHeroContainer">
        <div className="safetyAppHeroBackground"></div>
        <div className="safetyAppHeroContentContainer">
          <h1 className="largeHeadline white mb-4 textCentre">
            Keep Your Facility Compliant, <br /> Without the Headache
          </h1>

          <div className="heroTextContainer mb-4">
            <p className="largeBodyText white textCentre">
              The Safety App is designed to help you manage your facility's
              safety compliance with ease. From tracking incidents to managing
              safety training, our app provides a comprehensive solution for
              your safety needs.
            </p>
          </div>

          <div className="heroButtonContainer mt-4">
            <button className="roundBtn">Book a Demo</button>
          </div>
        </div>

        <div className="safetyAppHeroImageContainer">
          <img
            ref={imageRef}
            src={Placeholder}
            alt="Reports Dashboard"
            className="safetyAppHeroImage"
          />
        </div>
      </section>
      {/* <section className="clientLogosContainer">
        <h3 className="smallSUbhead">Trusted by companies all over</h3>
        <div className="clientLogos">
          <img
            src={SteelhausLogo}
            alt="Steelhaus Logo"
            className="clientLogo"
          />
          <img src={MaverickLogo} alt="Maverick Logo" className="clientLogo" />
          <img src={TrytonLogo} alt="Tryton Logo" className="clientLogo" />
        </div>
      </section> */}
    </>
  );
}
